import React from 'react';

export default function SubmitButton({ title, disabled }) {
    return (
        <div className="form-group">
            <button type="submit" className="button button--large button--fixed-glyph button--fixed-glyph-double" disabled={disabled}>
                <span className="button-title">{title}</span>

                <div className="button-submit-indicator">
                    <span /><span /><span />
                </div>
            </button>
        </div>
    );
}
